import React, { Component } from "react";
import { trackPromise } from 'react-promise-tracker';
import PagoServicioService from "../../../services/pagoServicios/pagoServicioService";
import DataTable from 'react-data-table-component';
import Popup from "react-popup";
import CabalTitulo from "./CabalTitulo"
import history from "../login/history";
import { formatoSeparadorMilesValue , reemplazarBarra , normalizarMonto } from '../../generico/utils/FormatoInput'
// import { formatoSeparadorMilesValue, splitImporte } from "../../generico/utils/FormatoInput";
import ConfigService from "../../../services/configuracion/ConfigService";
import { MENSAJE } from "../../generico/utils/Constantes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import { ModalPinTransaccional } from "../../generico/ModalPinTransaccional";
import pagoServicioServiceV2 from "../../../services/pagoServicios/pagoServicioServiceV2";

const COD_SERVICIO_SET = "55"; /// set
const COD_SERVICIO_TIGO = "474"; /// telepos


const AvisoSet = ({ codigo }) => {
  return (codigo === COD_SERVICIO_SET &&
    <div className="row invoice-info">
      <div className="col-12">
        <div className="row">
          <div className="col-md-12">
            <div
              className="callout callout-success"
              style={{
                border: "1px solid #006a2d",
                backgroundColor: "#ffffff00",
                boxShadow: "none",
              }}
            >
              <div className="row">
                <div className="col-md-12">
                  <i
                    className="fas fa-exclamation-circle card-fa-icono-info"
                    style={{ marginRight: 5, fontSize: 25 }}
                  />
                  <p style={{ fontSize: 20 }}>Importante!</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p class="mt-1 text-justify">{MENSAJE.TEXTO_SET}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default class SicoopPaso4 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      codigo: props.codigo,
      cedulaSocio:undefined,
      numeroSocio:undefined,
      numCuentaOrigen:undefined,
      datos:undefined
    };
  }

  componentDidMount() {

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
              history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
              window.location.reload();
            },
          },
        ],
      },
    });

  notifDoblePago = (props, state) =>

    Popup.register({
      title: "Atención!!!",
      content: "Ya se ha registrado un pago con el mismo número de boleta, por favor verifique los datos ingresados",
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
              history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
              window.location.reload();
            },
          },
        ],
      },

    });

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      }]
  }


  getDatos() {
    let respuesta = [];
    let valorPago = [];
    let montoFinal = "";
    let cliente = 0;
    let codigoSet = false;
    // let jsonData = JSON.parse(JSON.stringify(this.props.itemSelected));
    let jsonData = JSON.parse(JSON.stringify(this.props.paymentService));
    let datosSocio = JSON.parse(sessionStorage.getItem('socio'));
    if (this.props.datosCliente === null) {
      cliente = 1;
    }
    if (this.props.datosCliente === undefined) {
      cliente = 1;
    }
    if (cliente === 0) {
      respuesta.push({
        concepto:'Total a Pagar',
        valor:formatoSeparadorMilesValue(parseInt(this.props.monto)+parseInt(this.props.comision))
      });
      respuesta.push({
        concepto:'Comisión',
        valor : formatoSeparadorMilesValue(parseInt(this.props.comision))
      });
      for (let index = 0; index < this.props.datosCliente.length; index++) {
        respuesta.push({
          concepto: this.props.datosCliente[index].label,
          valor: this.props.datosCliente[index].value
        });

        valorPago.push({
          name: this.props.datosCliente[index].name,
          value: this.props.datosCliente[index].value
        });

      }
    }
    for (let i = 0; i < jsonData.length; i++) {
      let datos = JSON.parse(JSON.stringify(jsonData[i]));
      if ( datos.fieldType !== 7 ){
        let montoActual = datos.value;
        respuesta.push({
          // concepto:datos.label,  //SI ES PROPS.PASO3
          concepto:datos.label,    //SI ES PAYMENTSERVICE 
          valor: montoActual
        });
      }
    }
    if( this.props.modalidadPago === 'TCO' ){
      this.setState({
        cedulaSocio:datosSocio.numeroCedula,
        numeroSocio:datosSocio.numeroSocio,
        titularOriginante:datosSocio.nombreCompleto,
        numCuentaOrigen:this.props.cuentaOrigenSelected.value,
        datos:respuesta,
        datosPago:valorPago,
        total:montoFinal,
        codigoSet:codigoSet
      });
    }else{
      this.setState({
        cedulaSocio:datosSocio.numeroCedula,
        numeroSocio:datosSocio.numeroSocio,
        titularOriginante:datosSocio.nombreCompleto,
        numCuentaOrigen:this.props.cuentaOrigenSelected.ahorro,
        datos:respuesta,
        datosPago:valorPago,
        total:montoFinal,
        codigoSet:codigoSet
      });
    }
    // this.setState({ datos: respuesta, datosPago: valorPago, total: montoFinal, codigoSet: codigoSet });
  }


  pagar = (e) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    //// control de pago duplicado
    // this.esPagoDuplicado();
    this.procesarPagoV2();

  }

  esPagoDuplicado() {

    switch (this.props.codigo) {
      case COD_SERVICIO_SET:

        var nroBoleta = JSON.parse(JSON.stringify(this.state.datosPago[0])).value;
        var codigo = this.props.codigo
        var nroCuenta = this.props.nroCuenta
        var monto = this.state.total
        trackPromise(
          PagoServicioService.consultarPagoDuplicado(codigo, nroCuenta, monto, nroBoleta)
            .then((response) => {
              this.btn.removeAttribute("disabled");
              var data = JSON.stringify(response.data);
              var jsonData = JSON.parse(data);
              if (jsonData.codRetorno === '0') {
                if (jsonData.duplicado === "DUPLICADO_SI") {
                  Popup.queue(this.notifDoblePago(this.props, this.state));
                } else {
                  this.procesarPago();
                }
              }
              else {
                this.btn.removeAttribute("disabled");
                const resMessage = jsonData.desRetorno;
                this.setState({
                  loading: false,
                  message: resMessage
                });
              }
            })
            .catch(function (error) {
              console.log(error)
              var msg = "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.";
              Popup.queue(this.notifiPopup("Info", msg));
              return
            }));

        break;
      default:
        this.procesarPago();
        break;
    }

  }

  procesarPagoV2() {

    let cuentaSeleccionada = JSON.parse(JSON.stringify(this.props.cuentaOrigenSelected));
    let cuentaOrigen;
    let codOriginante = undefined;
    let modalidadPago = undefined;
    if( this.props.modalidadPago === 'TCO' ){
      if( this.props.tipoTarjeta === 'PANAL' ){
        codOriginante = '3601';
      }else{
        codOriginante = '1600';
      }
      cuentaOrigen = cuentaSeleccionada.value;
      modalidadPago = 'TCO';
    }else{
      codOriginante = '1607';
      cuentaOrigen = cuentaSeleccionada.ahorro;
      modalidadPago = 'CCAHOO';
    }
    
    let paymentService= [];
    this.props.paymentService.forEach(element => {
      // let value = (typeof element.value === "string") ? element.value.replaceAll(".","") : element.value;
      let value = element.isAmount ? 
        normalizarMonto(element.value) :
        ( element?.format === 'DATE' && this.props.barraAgregada && element.value.includes('/') ) ? 
        reemplazarBarra(element.value) : element.value
      // if( element?.format === 'DATE' && this.props.barraAgregada && element.value.includes('/') ){
      //   value = reemplazarBarra(value);
      // }
      paymentService.push({
        name:               element.name,
        value:              value,
        fieldType :         element.fieldType,
        notificationOrder : element.notificationOrder
      });
    });

    let idOperacionEF = "";
    
    let _numCuentaDestino = this.props.numCuentaDestino === undefined ? '0' : this.props.numCuentaDestino;

    let _docDestinatario = this.props.docDestinatario === undefined ? this.state.cedulaSocio : this.props.docDestinatario;

    // let monto = this.props.comision === undefined ? this.props.monto : String(parseInt(this.props.monto) + parseInt(this.props.comision)).toString();
    // monto +='00';
    let monto = this.props.comision === undefined ? normalizarMonto(this.props.monto) 
              // : String(parseInt(normalizarMonto(this.props.monto)) + parseInt(normalizarMonto(this.props.comision))).toString();
              : String(parseInt(normalizarMonto(this.props.monto)) + parseInt(normalizarMonto(this.props.comision)));
    monto = String(monto) + '00';
    

    const data = {
      canalOrigen : 'CU24HS_WEB',
      // titularDestinatario:this.props.empresa,
      docOriginante:this.state.cedulaSocio,
      idClienteEF:this.state.numeroSocio,
      titularOriginante:this.state.titularOriginante,
      numCuentaOrigen:cuentaOrigen,
      codOriginante:codOriginante,
      tipoCuentaOrigen:modalidadPago,
      numCuentaDestino:_numCuentaDestino,
      docDestinatario:_docDestinatario,
      importe:monto,
      idOperacionEF:idOperacionEF,
      id:this.props.idOperacion,
      paymentService:{
        // parameter:this.props.paymentService
        parameter:paymentService
      },
      aditionalParameters:null,
      detalleServicio: this.state.datos,
      codigoServicio: this.props.codigo,
      networkParticipantCode: this.props.networkParticipantCode,
      entidadId: this.props.entidadId
    }
    // console.log(data);
    trackPromise(
      pagoServicioServiceV2.pagarServicio( data )
        .then((response) => {
          if( response.status !== 200 ){
            Popup.queue(this.notifiPopup("Error", 'Error Inesperado. Intenta realizar el pago nuevamente o no dudes en contactar con nosotros si el problema persiste.'));
            this.btn.removeAttribute('disabled');
            // return;
          }
          if( response.data.datos.header.codRespuesta !== '0' ){
            Popup.queue(this.notifiPopup("Info", response.data.datos.header.txtRespuesta));
            this.btn.removeAttribute('disabled');
            // return;
          }
          if( response.data.datos.data.codRespuesta !== '0' ){ 
            Popup.queue(this.notifiPopup("Info", response.data.datos.data.txtRespuesta));
            this.btn.removeAttribute('disabled');
            // return;
          }
          if( response.data.codigo !== 0 ){
            Popup.queue(this.notifiPopup('Error',response.data.mensaje));
            this.btn.removeAttribute('disabled');
            // return;
          }
          // let ticket = response.data.datos.data;
          let idOperacion = response.data.datos.data.idOperacion;
          this.props.respuestaPaso4( paymentService , idOperacion , monto , this.state.datos );
          this.setState({ ticket: paymentService });
          if( response.data.datos.data.codRespuesta === '0' ){
            this.step5.click();
          }
        },
        error => {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          console.log(error);
          switch (this.props.codigo) {
            case COD_SERVICIO_SET:
              this.mostrarMensajePorServicio(this.props.codigo, '99');
              break;
            default:
              var msg = "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.";
              Popup.queue(this.notifiPopup("Info", msg));
              break;
          }
        }
      )
    );
  }



  volver = (e) => {
    this.setState({ datos: undefined });
    this.atras.click();
  }

  volverPagoServicio = (e) => {
    //history.push('/PagoServicio');
    history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
    window.location.reload();
  }


  /**
   * @author m_bareiro
   * Muestra mensaje personalizado dependiendo del servicio o metodo de pago
   * @param codServicio
   */
  mostrarMensajePorServicio(codServicio, codRetorno, mensajeServidor = '') {
    let msg;
    //// SET
    if (codServicio === COD_SERVICIO_SET && codRetorno !== '0') {
      msg = "Los pagos de SET son a confirmar. Verifique en el transcurso de 10 minutos en reimpresión de tickets si se encuentra aprobado su pago. Cualquier rechazo o inconveniente será contactado por funcionarios de la CU.";
      Popup.queue(this.notifiPopup("Info", msg));
      return
    }
    //// TIGO
    if (codServicio === COD_SERVICIO_TIGO && codRetorno === '0') {
      msg = "Pago por telepos tiene un tiempo de procesamiento de 24 a 48 hs. Para realizar pagos online de tigo, el cliente puede utilizar la opción Telefonia/Soluciones desde Cu24hs"
      Popup.queue(this.notifiPopup("Info", msg));
      return
    }
    //// mensaje para pago de codigo de barra
    if (this.props.esCodigoBarra === "OK" && codRetorno === '0') {
      msg = "Pago por código de barras tiene un tiempo de procesamiento de 24 a 48 hs.";
      Popup.queue(this.notifiPopup("Info", msg));
      return
    }
    //// cualquier otro servicio
    if (mensajeServidor !== '') {
      Popup.queue(this.notifiPopup("Info", mensajeServidor));
      return
    }

  }

  render() {
    if (this.props.currentStep !== 4) { // Prop: The current step
      return null;
    }

    if (this.props.currentStep === 4 && this.state.datos === undefined) {
      this.getDatos();
    }

    return (
        <div>
          {/******************* CABECERA WIZARD ***********************/}
          <div className="row">
            <div class="steps clearfix" style={{ marginBottom: 5 }}>
              <ul role="tablist">
                <li role="tab" class="disabled">
                  <span>
                    <div class="title">
                      <span class="title_text">{this.props.nombre}</span>
                    </div>
                  </span>
                </li>
                <li role="tab" class="disabled">
                  <span>
                    <div class="title">
                      <span class="title_text">Consulta</span>
                    </div>
                  </span>
                </li>
                <li role="tab" class="disabled">
                  <span>
                    <div class="title">
                      <span class="title_text">Cuenta</span>
                    </div>
                  </span>
                </li>
                <li role="tab" class="current">
                  <span>
                    <div class="title">
                      <span class="title_text">Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" class="disabled">
                  <span>
                    <div class="title">
                      <span class="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <CabalTitulo img={this.props.img} empresa={this.props.empresa} />
          <hr />

          {/******************* LOGICA PASOS ***********************/}
          <div className="row justify-content-md-center">
            <div className="col-md-8">
              <div className="form-group">
                {/* <label className="input-label"> */}
                {(this.props.modalidadPago === "TCO") &&
                  <label className="input-label-bold">
                    Número de Tarjeta (a debitar) *
                  </label>
                }
                {(this.props.modalidadPago === "CCAHOO") &&
                  <label className="input-label-bold">
                    {/* Seleccione la Tarjeta (a debitar) * */}
                    Cuenta Origen (a debitar) *:
                  </label>
                }
                  
                {/* </label> */}
                <br />
                <label className="input-label-bold">{this.state.numCuentaOrigen}</label><br />
                {/* <label className="input-label-bold">{this.props.cuenta}</label><br /> */}

              </div>
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-md-10 table-responsive">
              <div className="invoice p-3 mb-3">
                <div className="row">
                  <div className="col-12">
                    <h5>
                      Datos del Pago
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <DataTable
                    noHeader={true}
                    columns={this.getColumn()}
                    data={this.state.datos}
                    dense={true}
                    noDataComponent="No se tiene datos que mostrar"
                    responsive={true}
                    noTableHead={true} />
                </div>
              </div>
              <AvisoSet codigo={this.props.codigo} />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-4 btn-consulta">
              <button className="btn btn-cu-secundary" onClick={this.volverPagoServicio}><FontAwesomeIcon icon={faMoneyCheckDollar} /> Pagar Otro Servicio</button>
            </div>
            <div className="col-md-4 btn-consulta">
              <button className="btn btn-cu-quintary" onClick={this.volver} ><FontAwesomeIcon icon={faArrowLeft} /> Volver</button>
            </div>
            <div className="col-md-4">
              <button
                data-toggle="modal"
                data-target="#modal-pin-pago-servicio"
                className="btn btn-cu-primary"
                ref={btn => { this.btn = btn; }}>Confirmar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <ModalPinTransaccional id="modal-pin-pago-servicio" onSuccess={this.pagar} />
            </div>
            <button
              hidden
              ref={(a) => (this.step5 = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
            <button
              hidden
              ref={(a) => (this.atras = a)}
              className="btn btn-cu-primary"
              onClick={this.props.previousStep}
            ></button>
          </div>
        </div>
    );
  }
}